export default "__VITE_ASSET__f73fe58b__"